// Where a list row leads on D&D Beyond. Official and mundane catalogue entries
// carry their page URL; homebrew entries only search well by name (the canonical
// slug is not derivable, and the creations "view" link works only for the
// account's own items); inventory rows carry no URL at all and resolve through
// the cached catalogue, else a search by name.
import type { EquipmentRecord } from "./equipmentCache";

const DDB = "https://www.dndbeyond.com";
export const MAGIC_ITEM_ENTITY_TYPE_ID = "112130694";

export function itemSearchUrl(name: string, kind: { magical?: boolean; homebrew?: boolean } = {}) {
  const q = encodeURIComponent(name.trim());
  if (kind.homebrew) return `${DDB}/homebrew/magic-items?filter-search=${q}`;
  if (kind.magical) return `${DDB}/magic-items?filter-search=${q}`;
  return `${DDB}/equipment?filter-search=${q}`;
}

export function ownCreationUrl(itemId: string) {
  return `${DDB}/homebrew/creations/view?entityTypeId=${MAGIC_ITEM_ENTITY_TYPE_ID}&id=${itemId}`;
}

export function catalogUrl(record: Pick<EquipmentRecord, "name" | "sourceUrl" | "searchUrl" | "homebrew" | "magical">) {
  if (record.sourceUrl) return record.sourceUrl;
  if (record.searchUrl) return record.searchUrl;
  return itemSearchUrl(record.name, record);
}

export function inventoryItemUrl(item: { name: string; sourceUrl?: string; magical?: boolean; homebrew?: boolean }, catalog: EquipmentRecord[]) {
  if (item.sourceUrl) return item.sourceUrl;
  const name = item.name.trim().toLowerCase();
  const match = catalog.find((c) => c.name.trim().toLowerCase() === name && Boolean(c.homebrew) === Boolean(item.homebrew))
    || catalog.find((c) => c.name.trim().toLowerCase() === name);
  return match ? catalogUrl(match) : itemSearchUrl(item.name, item);
}

export function openItemPage(url: string) {
  if (url) window.open(url, "_blank", "noopener,noreferrer");
}
